/* Configurateur Maison Reposéa : moteur de sélection (23/10/2026, revu 26/10 ; 28/10 : venu d’une fiche, le produit reste la pièce centrale, jamais remplacé par moins cher). Règles : rf-config-regles.js ; affichage : snippets rf-config-ui-a/b/c. */
(function () {
var R = window.RFC; if (!R) return;
var AC = 'àâäáãéèêëíìîïóòôöõúùûüçñ', NA = 'aaaaaeeeeiiiiooooouuuucn';
function norm(s) { s = String(s || '').toLowerCase(); var o = ''; for (var i = 0; i < s.length; i++) { var k = AC.indexOf(s[i]); o += k < 0 ? s[i] : NA[k]; } return o; }
function toks(s) { return norm(s).split(/[^a-z0-9]+/); }
function has(a, x) { return !!a && a.indexOf(x) >= 0; }
function inter(a, b) { a = a || []; for (var i = 0; i < a.length; i++) if (has(b, a[i])) return true; return false; }
var KIDONLY = ['Philibert', 'Barnabé'], WL = ['Rechargeable (sans fil)', 'Solaire', 'À piles'];
function roleOf(p) {
  var t = p.ty || '', r = [];
  if (/Suspension|Plafonnier/.test(t)) r.push('plafond');
  else if (/Applique|Liseuse/.test(t)) r.push('mur');
  else if (t == 'Veilleuse') r.push('veille');
  else if (/Guirlande/.test(t)) r.push('guirlande', 'ambiance');
  else if (t == 'Lampe de table') r.push('poser');
  else r.push('ambiance');
  if (has(p.tg, 'lampe-de-chevet') && !has(r, 'poser')) r.push('poser');
  if (has(p.al, 'Solaire') && !has(r, 'mur')) r.push('solaire');
  return r;
}
function optIdx(p, re) { var o = p.o || []; for (var i = 0; i < o.length; i++) if (re.test(norm(o[i]))) return i; return -1; }
R.norm = norm; R.has = has; R.inter = inter;
R.prep = function (P) {
  P.forEach(function (p) {
    p.pc = p.pc || []; p.al = p.al || []; p.tg = p.tg || []; p.c = p.c || []; p.m = p.m || [];
    var w = (p.n || '').split(' '); p.key = w[w.length - 1];
    p.st = []; for (var k in R.sm) if (has(R.sm[k].split(' '), p.key)) p.st.push(k);
    if (!p.st.length) {
      if (inter(p.m, ['Bois & bambou', 'Papier', 'Céramique', 'Tissu'])) p.st.push('nature');
      if (has(p.m, 'Verre') && has(p.c, 'Doré & laiton')) p.st.push('chic');
      if (p.c.length > 3 || has(p.c, 'Multicolore')) p.st.push('couleur');
      if (!p.st.length) p.st.push('epure');
    }
    p.kid = has(R.enfant.split(' '), p.key); p.kidOnly = has(KIDONLY, p.key) || has(p.tg, 'enfant');
    p.r = roleOf(p); p.cf = p.c.map(function (x) { return R.fc[x]; }).filter(Boolean);
    p.ci = optIdx(p, /coul|colori|finition|pavillon/); p.qi = optIdx(p, /quantit/);
    p.ti = optIdx(p, /temp|lumiere|eclairage/); p.ai = optIdx(p, /aliment/);
    p.tx = norm(p.t + ' ' + p.a); p.wl = inter(p.al, WL);
  });
};
function vcount(p, v) { if (p.qi < 0) return 1; var s = norm(v.o[p.qi]); if (s.indexOf('paire') >= 0) return 2; var m = s.match(/lot de ([0-9]+)/); return m ? +m[1] : 1; }
function vfams(p, v) {
  if (p.ci >= 0) { var f = []; toks(v.o[p.ci]).forEach(function (t) { var x = R.kw[t]; if (x && !has(f, x)) f.push(x); }); if (f.length) return f; }
  return p.cf;
}
function vtemp(p, v) {
  if (p.ti < 0) return ''; var s = norm(v.o[p.ti]);
  if (/neutre|naturel/.test(s)) return 'neutre'; if (/froid/.test(s)) return 'froid';
  if (/teintes/.test(s)) return 'reglable'; if (/multi/.test(s)) return 'multi'; return 'chaud';
}
function vwl(p, v) { if (p.ai < 0) return p.wl; return /sans fil|batterie|rechargeable|piles/.test(norm(v.o[p.ai])); }
function cscore(f, map) { if (!f.length) return 1.5; var t = 0; f.forEach(function (x) { t += map[x] != null ? map[x] : 1; }); return t / f.length; }
R.vcount = vcount;
function eligible(p, x, roles) {
  if (!inter(p.pc, x.room[2])) return false;
  if (x.rid == 'enfant') { if (!p.kid) return false; } else if (p.kidOnly) return false;
  if (x.rid == 'sdb' && p.ty == 'Bougie LED') return false;
  if (roles && !inter(p.r, roles)) return false;
  var c = x.cons, fixe = has(p.r, 'mur') || has(p.r, 'plafond');
  if (has(p.r, 'plafond')) { if (has(c, 'noplafond')) return false; if (has(c, 'bas') && p.ty == 'Suspension') return false; }
  if (has(c, 'sansprise') && !fixe && !p.wl) return false;
  if (has(c, 'location') && has(p.r, 'mur') && !inter(p.al, ['Sur prise'].concat(WL))) return false;
  if (has(c, 'noelec') && !p.wl) return false;
  return true;
}
function best(p, x, q, used) {
  var b = null, fixe = has(p.r, 'mur') || has(p.r, 'plafond');
  p.v.forEach(function (v) {
    if (!v.a) return;
    if ((has(x.cons, 'noelec') || (has(x.cons, 'sansprise') && !fixe)) && !vwl(p, v)) return;
    var cnt = vcount(p, v), unit = v.p / cnt;
    if (x.cap && unit > x.cap * 1.1) return;
    var f = vfams(p, v), cs = cscore(f, x.map), s = cs * 4, cq = 1, t = vtemp(p, v);
    if (inter(p.st, [x.style])) s += 6;
    if (t) { if (t == x.temp) s += 2; else if (t == 'reglable') s += 1.5; else if (t == 'froid') s -= 2; }
    if (q > 1) { if (cnt == q) s += 5; else if (cnt == 1) { cq = q > 2 ? 2 : q; s += 1; } else if (cnt == 2 && q == 3) s += 2; else s -= 4; }
    else { if (cnt > 1) s -= 6; else s += 1; }
    if (used && inter(f, used)) s += 2;
    if (x.av && p.h == x.ah && p.ci >= 0 && v.o[p.ci] == x.av.o[p.ci]) s += 20;
    if (x.rid == 'bureau' && /liseuse|orientable|cygne|lecture|bureau/.test(p.tx)) s += 4;
    if (x.rid == 'cuisine' && p.ty == 'Suspension') s += 2;
    if (x.home == 'petit') { if (has(p.r, 'mur') || vwl(p, v)) s += 1.5; if (p.ty == 'Suspension' && x.rid != 'cuisine') s -= 2; }
    if (x.home == 'neutre') { if (has(p.r, 'poser') || has(p.r, 'ambiance')) s += 1.5; if (t == 'chaud') s += 1; }
    s -= unit / 50000;
    if (!b || s > b.s) b = { p: p, v: v, s: s, cs: cs, fams: f, cq: cq, cnt: cnt, total: v.p * cq };
  });
  return b;
}
function rank(x, roles, q, excl, used, bonus) {
  var l = [];
  R.P.forEach(function (p) {
    if (has(excl, p.h) || !eligible(p, x, roles)) return;
    var b = best(p, x, q, used); if (!b) return;
    if (bonus && inter(p.r, bonus)) b.s += 8;
    l.push(b);
  });
  return l.sort(function (a, b) { return b.s - a.s; });
}
var PRIO = { poser: ['poser'], mur: ['mur'], plafond: ['plafond'], ambiance: ['ambiance', 'veille', 'guirlande'], solaire: ['solaire'], guirlande: ['guirlande'] };
function find(a, id) { for (var i = 0; i < a.length; i++) if (a[i][0] == id) return a[i]; return null; }
R.ctx = function (A) {
  var room = find(R.rooms, A.room), w = find(A.room == 'ext' ? R.facades : R.walls, A.wall);
  return { rid: A.room, room: room, w: w, map: w ? w[3] : {}, style: A.style, cons: A.cons || [], cap: +A.budget || 0, home: A.home || '',
    temp: A.room == 'bureau' ? 'neutre' : 'chaud' };
};
R.compute = function (A) {
  var x = R.ctx(A), pr = PRIO[A.prio], spot = null, ens = [], used = [], excl = [], spotIn = false, an = null, floor = 0, aL = [];
  if (R.anchor && R.anchor.h) R.P.forEach(function (p) { if (p.h == R.anchor.h) an = p; });
  if (an) {
    var xa = {}; for (var k in x) xa[k] = x[k]; xa.cap = 0; xa.ah = an.h;
    an.v.forEach(function (v) { if (String(v.id) == R.anchor.v) xa.av = v; });
    x = xa; spot = best(an, x, 1, null); aL = an.r;
    if (spot) floor = spot.v.p / spot.cnt;
  } else if (pr) { var l0 = rank(x, pr, 1, [], null); spot = l0[0] || null; }
  (R.layers[A.room] || []).forEach(function (L) {
    var list = rank(x, L[0], L[1], excl, used);
    if (spot && !spotIn && inter(spot.p.r, L[0])) {
      var sb = best(spot.p, x, L[1], used);
      if (sb) {
        list = list.filter(function (b) { return b.p.h != spot.p.h && (!an || b.v.p / b.cnt >= floor); });
        list = [sb].concat(list); spotIn = true; if (an) aL = L[0];
      }
    }
    if (!list.length) return;
    ens.push({ L: L, alts: list.slice(0, 8), i: 0 });
    excl.push(list[0].p.h); used = used.concat(list[0].fams);
  });
  if (spot && !spotIn) excl.push(spot.p.h);
  var others = rank(x, null, 1, excl, used, pr).filter(function (b) { return !an || !inter(b.p.r, aL) || b.v.p / b.cnt >= floor; }).slice(0, 6);
  return { x: x, spot: spot, spotIn: spotIn, ens: ens, others: others, anchor: an };
};
})();